import { gql } from '@apollo/client/core'

export const GET_PATIENT_ORDER = gql`
  query PatientProfile(
    $patientId: String!
    $accessionId: String!
    $sampleId: String!
    $customerId: String!
    $clinicId: String!
  ) {
    patientProfile(
      PatientProfileInput: {
        patient_id: $patientId
        accession_id: $accessionId
        sample_id: $sampleId
        customer_id: $customerId
        clinic_id: $clinicId
      }
    ) {
      order {
        errorMessage
        data {
          accession_id
          sample_id
          order_id
          order_status
          service_date
          original_price
          actual_price
          total
          payment_info
          order_source
          order_time_line {
            status
            time
          }
        }
      }
    }
  }
`

// list patients by patient ids query
export const LIST_PATIENTS = gql`
  query Listpatients($patientIds: [String!]!) {
    listpatients(patientIDListInput: { patient_ids: $patientIds }) {
      errorMessage
      data {
        response {
          patient_id
          patient_gender
          patient_first_name
          patient_last_name
          patient_middle_name
          patient_birthdate
          patient_address {
            address_id
            address_type
            street_address
            apt_po
            city
            state
            zipcode
            country
          }
          patient_contact {
            contact_id
            contact_description
            contact_details
            contact_type
          }
        }
      }
    }
}
`